// src/components/Typography.js
// Editorial Vitality type system — Epilogue (headline) + Plus Jakarta Sans (body)
import styled from 'styled-components';
import tokens from '../styles/tokens';

const { 'on-surface': onSurface, 'on-surface-variant': onSurfaceVariant, primary } = tokens.colors;

// Display — hero headlines, name, big statements
export const Display = styled.h1`
  font-family: 'Epilogue', sans-serif;
  font-size: clamp(2.5rem, 6vw, 4rem);
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -0.02em;
  color: ${onSurface};
`;

// Heading — section titles, card headings
export const Heading = styled.h2`
  font-family: 'Epilogue', sans-serif;
  font-size: clamp(1.5rem, 3vw, 1.875rem);
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.01em;
  color: ${onSurface};
`;

// Subheading — project titles, category labels
export const Subheading = styled.h3`
  font-family: 'Epilogue', sans-serif;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.35;
  color: ${onSurface};
`;

// Body — readable paragraph text
export const Body = styled.p`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.7;
  color: ${onSurfaceVariant};
`;

// Label — stats, tags, chips, captions
export const Label = styled.span`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${onSurfaceVariant};
`;

// Accent — terracotta highlight text (for emphasis within headlines)
export const Accent = styled.span`
  color: ${primary};
`;
